import React from 'react';

import Group from '@pb/kit-component-group';
import Icon from '@pb/kit-component-icon';
import Typography from '@pb/kit-component-typography';

import {navCard, navCardIcon} from '../dashboard.module.styl';

type NavCardItemProps = {
    label: string,
    icon: string,
    onClick: () => void,
};

export const NavCardItem: React.FC<NavCardItemProps> = ({label, icon, onClick}) => (
    <Group className={navCard} onClick={onClick} alignItems="center" direction="h" gap="m">
        <Group className={navCardIcon} alignItems="center" justify="center">
            <Icon type={icon} size="Size_24"/>
        </Group>
        <Typography variant="body-level-1">{label}</Typography>
    </Group>
);
